<template>
  <form>
    <div
      class="row"
      style="
        border-bottom: 2px solid #115E67;
        margin-bottom: 10px;
        font-size: 20px;
        padding: 5px 0px 0px 5px;
        margin-top: 30px;
      "
    >
      <label style="margin: 0px">Vendor</label>
    </div>
    <div style="border: 1px #d4d4d4 solid; padding: 20px; margin-bottom: 20px">
      <div class="form-group row col-md-12">
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Vendor</label
          >
          <label
            v-if="profile.vendor_name"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ profile.vendor_name }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Country</label
          >
          <label
            v-if="profile.country_code"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ profile.country_code }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Annual Sales Goal</label
          >
          <label
            v-if="profile.annual_goal"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ profile.annual_goal }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Active</label
          >
          <label
            v-if="profile.active"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style capital"
            >{{
              profile.active +
              (profile.disable_date
                ? " (Disables on: " +
                  getFormattedDate(profile.disable_date) +
                  ")"
                : "")
            }}</label
          >
          <label
            v-else-if="profile.active == false"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style capital"
            >{{
              profile.active +
              (profile.disable_date
                ? " (Disabled on: " +
                  getFormattedDate(profile.disable_date) +
                  ")"
                : "")
            }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style">Partner UUID</label>
          <label
            v-if="profile.partner_uuid"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
          >{{profile.partner_uuid }}</label>
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
          >Not Provided</label>
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style">Go Retail Contact</label>
          <label
            v-if="profile.go_retail"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
          >{{profile.go_retail.first_name + ' ' + profile.go_retail.last_name}}
          </label>
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
          >Not Provided</label>
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style">Go Marketing Contact</label>
          <label
            v-if="profile.go_marketing"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
          >{{profile.go_marketing.first_name + ' ' + profile.go_marketing.last_name}}</label>
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
          >Not Provided</label>
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style">Go Ops Contact</label>
          <label
            v-if="profile.go_ops"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
          >{{profile.go_ops.first_name + ' ' + profile.go_ops.last_name}}</label>
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
          >Not Provided</label>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {};
  },
  props: ["profile","clientData"],
  components:{moment},
  methods: {
    getFormattedDate(date) {
        return  moment(date).format("MM/DD/YYYY");
    },
    parsedContacts(data) {
      let str = "";
      if (data) {
        if (data.first_name) {
          str = data.first_name;
        }
        if (data.last_name) {
          str = str + " " + data.last_name;
        }
      }
      return str;
    }
  },
};
</script>